module.exports = __webpack_public_path__ + "img/pharmacy.2ce22f01.jpg";